import React, { useState } from "react";
import BridgeContainer from "./bridge/BridgeContainer";
// import BridgeHistorySwitch from "./bridgeHistory/BridgeHistorySwitch";
import PowerdBy from "./footer/PowerdBy";
import HistoryContainer from "./history/HistoryContainer";
// import useSnackBar from "../../helper/CallSnackBar";

function MainContainer({ netWroks, setNetWroks }) {
  const [content] = useState("bridge");
  // const { snackBar, setSnackBar } = useSnackBar();

  //------Here below explain how to call snack bar and set message into it---------stat
  // const { snackBar, setSnackBar }=  useSnackBar()
  // setSnackBar({type:"success", message:"bridge Success"})
  // setSnackBar({type:"danger", message:"bridge in danger"})
  // setSnackBar({type:"processing", message:"bridge in processing"})
  // setSnackBar({type:null, message:""})  //---for remove snack bar
  //------Here above explain how to call snack bar and set message into it---------end
  return (
    <div className=" w-full max-w-[37.7rem] flex flex-col gap-2">
      <div className="flex justify-between">
        {/* <button
          onClick={() => {
            setSnackBar({ message: "success", type: "success" });
          }}
        >
          SnackBar-success
        </button>
        <button
          onClick={() => {
            setSnackBar({ message: "processing", type: "processing" });
          }}
        >
         SnackBar-processing
        </button>
        <button
          onClick={() => {
            setSnackBar({ message: "danger", type: "danger" });
          }}
        >
          SnackBar-danger
        </button> */}
      </div>
      {/* <div className="bg-sunny-secondary text-sm  dark:bg-dark-secondary  rounded-2xl">
        <BridgeHistorySwitch content={content} onClick={setContent} />
      </div> */}
      <div className="bg-sunny-secondary border border-solid border-sunny-border dark:border-dark-border  dark:bg-dark-secondary rounded-2xl h-[40.6rem] p-5">
        {content === "bridge" ? (
          <BridgeContainer netWroks={netWroks} setNetWroks={setNetWroks} />
        ) : (
          <HistoryContainer />
        )}
      </div>
      <div className=" mt-3">
        <PowerdBy />
      </div>
    </div>
  );
}

export default MainContainer;
